<template>
<div class="chapter">
<div class="inner_page">
<div id="V4305ebook-5.html" xml:lang="en-US">
<div class="Basic-Text-Frame">
<p class="CT para-style-override-1" id="toc_marker-6"><span class="char-style-override-2">for</span></p>
<p class="BT-1st-Para para-style-override-2"><span class="char-style-override-9">Nora York</span></p>
<p class="BT-1st-Para para-style-override-7">who </p>
<p class="BT-1st-Para para-style-override-2">blew in from Winnetka</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// V4305ebook5.vue?93de64d0